import React from 'react'
import { Container, Col, Row } from '@paypalcorp/pp-react-grid'

import ComputerAndPhone from '../../../../icons/computerandphone'
import data from '../../../../content/home/home.en-XC.yaml'
import ComputerIcon from '../../../../icons/computerIcon'
import Arrow from '../../../../icons/arrow'
import CreditCard from '../../../../icons/creditCard'
import House from '../../../../icons/house'
import Phone from '../../../../icons/phone'
import TwoCards from '../../../../icons/twoCards'

import './style.css'

const AcceptPayments = () => {
  const { tiles } = data.content.accept_payments || []

  const Icons = {
    Computer: <ComputerIcon />,
    Arrow: <Arrow />,
    CreditCard: <CreditCard />,
    House: <House />,
    Phone: <Phone />,
    TwoCards: <TwoCards />,
  }

  return (
    <section className="mainInfo">
      <Container>
        <Row>
          <Col className="floatCol" md={8}>
            <h3 className="headerTop">Accept Payments</h3>
            <Row className="infoRow">
              {tiles.map((tile, key) => {
                return (
                  <Col key={key} md={6} className="floatCol acceptPayments-col">
                    <div className="headerIcon">
                      <div className="iconWrapper">{Icons[tile.icon]}</div>
                      <h4 className="infoTitle">
                        <a href={tile.link || '#'}>{tile.title}</a>
                      </h4>
                    </div>
                    <p className="infoText">{tile.description}</p>
                    {tile.links.map((link, key) => {
                      return (
                        <a
                          key={key}
                          href={link.url}
                          target={
                            link.url &&
                            link.url.startsWith('http') &&
                            !link.url.includes('developer.paypal.com')
                              ? '_blank'
                              : '_self'
                          }
                          rel="noreferrer"
                          className="infoLink"
                        >
                          {link.title}
                        </a>
                      )
                    })}
                  </Col>
                )
              })}
            </Row>
          </Col>
          <Col className="floatCol" md={4}>
            <div className="computerWrapper">
              <ComputerAndPhone />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  )
}

export default AcceptPayments
